import { NofomoThemeConfig } from '@mdlbeasts/nofomo.ui.web';
import { ThemeOptions } from '@mui/material';

export const defaultThemeOptions: ThemeOptions = NofomoThemeConfig;
